
import throttle from './../utility/throttle'

const el = document.querySelector('.js-fade-on-scroll')

function scrollHandler() {
	return (window.pageYOffset > 500) ? el.classList.add('opacity-0') : el.classList.remove('opacity-0')
}

export function fadeOnScroll() {
	scrollHandler()
	document.addEventListener('scroll', throttle(scrollHandler, 40))
}


